export function truncateString(
  str: string | null | undefined,
  maxLength: number,
): string {
  if (!str) {
    return '';
  }
  if (str.length > maxLength) {
    return `${str.slice(0, maxLength - 3)}...`;
  }
  return str;
}

export const splitFullName = (fullName: string) => {
  const trimmedName = fullName.trim();
  const lastSpaceIndex = trimmedName.lastIndexOf(' ');
  return {
    firstName:
      lastSpaceIndex > -1 ? trimmedName.slice(0, lastSpaceIndex) : trimmedName,
    lastName: lastSpaceIndex > -1 ? trimmedName.slice(lastSpaceIndex + 1) : '',
  };
};
